import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import {jsPDF} from 'jspdf';  
import { OrderService } from 'src/app/core/services/order.service';

@Component({
  selector: 'app-view-page',
  templateUrl: './view-page.component.html',
  styleUrls: ['./view-page.component.scss']
})
export class ViewPageComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private orderService : OrderService
  ) { }

  invoiceData: any
  viewId:any


  @ViewChild('content', {static: false}) content: ElementRef | any; 

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (params.invoiceId) {
        this.viewId = params.invoiceId
        this.getInvoiceById()
      }
      if (params.estimateId) {
        this.viewId = params.estimateId
        this.getEstimateById()
      }
    })
  }

  getInvoiceById() {
    this.orderService.getInvoiceById(this.viewId).subscribe(res => {
      this.invoiceData = res.invoice
    })
  }
  getEstimateById() {
    this.orderService.getEstimateById(this.viewId).subscribe(res => {
      this.invoiceData = res.estimate
    })
  }

  downloadPDF() {
    let content = this.content.nativeElement;
    html2canvas(content, { allowTaint: true, useCORS: true }).then(canvas => {
      var imgWidth = 208;
      // var pageHeight = 295;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      // var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
      var position = 0;
      pdf.addImage(contentDataURL, 0, position, imgWidth, imgHeight)
      pdf.save('MYPdf.pdf'); // Generated PDF
    })
  }

}
